import {
  Controller,
  type FieldValues,
  type Control,
  type Path,
} from 'react-hook-form';

export type CheckboxProperties<T extends FieldValues> = {
  readonly control: Control<T>;
  readonly name: Path<T>;
  readonly label?: string;
  readonly errorMessage?: string;
  readonly className?: string;
};

export function Checkbox<T extends FieldValues>({
  control,
  name,
  label,
  errorMessage,
  className,
}: CheckboxProperties<T>) {
  return (
    <div className={`${className ?? ''}`}>
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <div className='flex items-center gap-2'>
            <input
              type='checkbox'
              id={name}
              checked={field.value ?? false}
              className='h-4 w-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500'
              {...field}
              value={undefined}
              onChange={(event) => {
                field.onChange(event.target.checked);
              }}
            />
            {label && (
              <label
                htmlFor={name}
                className='cursor-pointer text-sm font-medium text-gray-900 dark:text-white'
              >
                {label}
              </label>
            )}
          </div>
        )}
      />
      {errorMessage && (
        <p className='mt-1 text-center text-sm text-red-600'>{errorMessage}</p>
      )}
    </div>
  );
}
